import { COLORS } from "@coeff/utils";
import React from "react";
import styled from "styled-components";

const Section = styled.section<{ noMargin?: boolean }>`
  margin: ${({ noMargin }) => (noMargin ? 0 : "15px")};
  background: ${COLORS.coeblue};
  border-radius: 5px;
`;

const StyledPanel = styled.div`
  padding: 10px;
  color: ${COLORS.black85};

  .body {
    margin: 6px 6px 0px;
    line-height: 18px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    white-space: pre-line;
    text-align: center;
  }

  .id {
    margin: 16px 0px 6px;
    font-weight: bold;
  }
`;

export type ReAuthInfoProps = {
  message?: string;
  uniqueId?: string;
  additionalLabel?: string;
};

export const ReAuthInfo: React.FC<ReAuthInfoProps> = ({
  message,
  uniqueId,
  additionalLabel,
  ...props
}) => {
  const displayMessage = message
    ? message
    : "Make sure you connect with the same account you used to create the data source";
  return (
    <Section
      data-sentry-unmask
      data-testid="reauth-info-card"
      className="coeff__reauth-info"
      {...props}
    >
      <StyledPanel>
        {displayMessage && <div className="body">{displayMessage}</div>}
        <div className="body id">
          {uniqueId && <div>{uniqueId}</div>}
          {additionalLabel && <div>{additionalLabel}</div>}
        </div>
      </StyledPanel>
    </Section>
  );
};
